/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BlogManagerEditArticleRequest = {
  id: number;
  groupId?: number;
  title?: string;
  context?: string;
  postDate?: string;
  openSatatus?: BlogManagerEditArticleRequest.openSatatus;
  releaseSetting?: BlogManagerEditArticleRequest.releaseSetting;
  imageIds: Array<string>;
  tagIds?: string;
  postGroupIds?: string;
};

export namespace BlogManagerEditArticleRequest {
  export enum openSatatus {
    EDIT = "edit",
    OPEN = "open",
    Z_DELETE = "z_delete",
  }

  export enum releaseSetting {
    NOW = "now",
    DATE = "date",
  }
}
